<div mat-dialog-content>
    <i class="fa fa-close text-grey" (click)="onClose(false)" aria-hidden="true"></i>

    <div id="picturesCarousel-{{rand}}" class="carousel slide picturesCarousel hide-mobile" data-ride="carousel">
        <div class="carousel-inner">
            <div *ngFor="let picture of favorite.pictures; index as i;"
                 [ngClass]="{'carousel-item': true, 'active': i == current}">
                <img *ngIf="!picture.includes('ubiflow')" src="{{ picture }}" />
                <img *ngIf="picture.includes('ubiflow')" src="{{apiUrl}}img/{{ favorite.id }}/{{i}}?rand={{rand}}" />
            </div>
        </div>

        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-prev"
                type="button"
                [attr.data-bs-target]="'#picturesCarousel-' + rand"
                data-bs-slide="prev">
            <i class="fa fa-chevron-left"></i>
            <span class="visually-hidden">Previous</span>
        </button>
        <button *ngIf="favorite.pictures.length > 1" class="carousel-control-next"
                type="button"
                [attr.data-bs-target]="'#picturesCarousel-' + rand"
                data-bs-slide="next">
            <i class="fa fa-chevron-right"></i>
            <span class="visually-hidden">Next</span>
        </button>
    </div>

    <div class="visible-mobile">
        <img *ngFor="let picture of favorite.pictures; index as i;" src="{{ picture }}" class="mb-1 img-fluid w-100">
    </div>
</div>
